
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcSequenceToolbar as ObcSequenceToolbarElement} from '@oicl/openbridge-webcomponents/dist/components/sequence-toolbar/sequence-toolbar.js';
 
 
 

 
 export const ObcSequenceToolbar = createComponent({
   react: React,
   tagName: 'obc-sequence-toolbar',
   elementClass: ObcSequenceToolbarElement,
   events: {
     
     onPrevClick: 'prev-click' as EventName<CustomEvent<unknown>>,
     onNextClick: 'next-click' as EventName<CustomEvent<unknown>>,
     onAddClick: 'add-click' as EventName<CustomEvent<unknown>>,
   }
  });
 
 